export enum Role {
  MANAGER = 'MANAGER',
  CUSTOMER = 'CUSTOMER',
  PARTNER = 'PARTNER',
}

export interface User {
  id: number;
  username: string;
  email: string;
  confirmed: boolean;
  blocked: boolean;
  firstname: string;
  mobilephone: string;
  lastname: string;
  numero_contrat: string;
  raison_sociale_entreprise: string;
  resetPasswordTokenCreatedAt: null;
  salesforce_contact_id: string;
  salesforce_account_id: string;
  createdAt: Date;
  updatedAt: Date;
  role: Role;
  createdBy?: User;
  updatedBy?: User;
  avatarUrl?: string;
  avatarId?: string;
}
